module.exports = __webpack_public_path__ + "static/media/Efficiency.85bb4671.png";